import { useGetVendorByName } from "@/common/api/queries";
import { Select, Spin } from "antd";
import { useEffect, useState } from "react";

export default function SearchVendorByName({
  func,
}: {
  func: (data: { value: number; label: string }) => void;
}) {
  const [searchQ, setSearchQ] = useState<string>("");
  const [vendorsOptions, setVendorsOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const onSearch = (value: string) => {
    setSearchQ(value);
  };
  const { data: vendors, isLoading, isError } = useGetVendorByName(searchQ);
  const onSelect = (option: { value: number; label: string }) => {
    func(option);
  };
  useEffect(() => {
    if (!vendors) return;
    const values = vendors.items.map((el) => ({
      value: el.id,
      label: el.companyName,
    }));
    setVendorsOptions(values);
  }, [vendors]);

  return (
    <div className="w-full">
      <Select
        showSearch
        labelInValue
        rootClassName="!bg-gray-border min-w-[290px] rounded-lg !py-2.5 w-full h-10 "
        popupClassName="!z-20 max-h-fit h-fit !bg-white"
        filterOption={false}
        searchValue={searchQ}
        onSearch={onSearch}
        onSelect={onSelect}
        placeholder="Search vendor by company name"
        options={vendorsOptions}
        notFoundContent={
          isLoading || isError ? <Spin size="small" /> : "No vendors found"
        }
      />
    </div>
  );
}
